export function getdata() {
	let obj = {
		searchlist: [{
				prop: "h_pingzh",
				label: 'ERP凭证号',
				type: "input",
			},
			{
				prop: "h_xitpzh",
				label: '系统凭证号',
				type: "input",
			},
			{
				prop: "h_cain",
				label: '凭证年度',
				type: "select",
				selectval: []
			},
			{
				prop: "h_qij",
				label: '凭证期间',
				type: "select",
				selectval: []
			},
			{
				prop: "h_pingzrq",
				label: '凭证日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "h_daorpch",
				label: '导入批次号',
				type: "input",
			},
			{
				prop: "h_pingzlx",
				label: '凭证类型',
				type: "select",
				selectval: [{
					label: "正常凭证",
					value: "0"
				}, {
					label: "调整凭证",
					value: "1"
				}]
			},
			{
				prop: "h_guozrq",
				label: '过账日期',
				type: "date",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "h_guozzt",
				label: '过账状态',
				type: "select",
				selectval: [{
					label: "未过账",
					value: "0"
				}, {
					label: "已过账",
					value: "1"
				}]
			},
			{
				prop: "d_zhongfkm",
				label: '中方科目',
				type: "select",
				selectval: [],
			},
			{
				prop: "d_erpkm",
				label: 'ERP科目',
				type: "input",
			},
		],
		searchdata: {
			h_pingzh: '',
			h_xitpzh: '',
			h_daorpch: '',
			h_cain: '',
			h_qij: '',
			h_pingzlx: '',
			h_guozzt: '',
			d_zhongfkm: '',
			d_erpkm: '',
			h_pingzrq: [],
			h_guozrq: [],
		},
		headData: [{
				title: "ERP凭证号",
				prop: "pingzh",
				width: "140",
				custom: true,
				issort: true,
			},
			{
				title: "系统凭证号",
				prop: "xitpzh",
				width: "140",
				issort: true,
			},
			{
				title: "凭证年度",
				prop: "cain",
				width: "120",
				issort: true,
			},
			{
				title: "凭证期间",
				prop: "qij",
				width: "120",
				issort: true,
			},
			{
				title: "凭证类型",
				prop: "pingzlx",
				width: "120",
				custom: true,
				issort: true,
			},
			{
				title: "过账状态",
				prop: "guozzt",
				width: "120",
				custom: true,
				issort: true,
			},
			{
				title: "本币借方金额合计",
				prop: "benbjfje",
				width: "160",
				issort: true,
				AmountFormat: true,
			},
			{
				title: "本币贷方金额合计",
				prop: "benbdfje",
				width: "160",
				issort: true,
				AmountFormat: true,
			}, {
				title: "原币借方金额合计",
				prop: "yuanjfje",
				width: "160",
				issort: true,
				AmountFormat: true,
			}, {
				title: "原币货方金额合计",
				prop: "yuandfje",
				width: "160",
				issort: true,
				AmountFormat: true,
			}, {
				title: "凭证日期",
				prop: "pingzrq",
				width: "120",
				issort: true,
			}, {
				title: "过账时间",
				prop: "guozrq",
				width: "120",
				issort: true,
			},
			// {
			// 	title: "过账人",
			// 	prop: "tes8",
			// 	width: "100"
			// },
			{
				title: "最后编辑时间",
				prop: "gengxsj ",
				width: "140",
				issort: true,
			},
			// {
			// 	title: "编辑人",
			// 	prop: "tes8",
			// 	width: "100"
			// },
			{
				title: "凭证来源",
				prop: "pingzly",
				width: "120",
				issort: true,
			},
			{
				title: "会计主管",
				prop: "kuaijzg",
				width: "120",
				issort: true,
			},
			{
				title: "制单人",
				prop: "zhidr",
				width: "120",
				issort: true,
			}, {
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formtime: [{
				prop: "h_pingzrq",
				label: "凭证日期",
				type: "input",
				slot: true,
			},
			{
				prop: "h_guozrq",
				label: "凭证过账日期",
				type: "input",
				slot: true,
			}
		],

		formdata: {
			h_pingzrq: [],
			h_cain: "",
			h_qij: "",
			h_pingzh: "",
			h_xitpzh: "",
			h_pingzlx: "",
			h_guozzt: "",
			d_erpkm: "",
			d_zhongfkm: "",
			h_benbjfje: "",
			h_benbdfje: "",
			h_daorpch: "",
			d_yuanbz: "",
			h_guozrq: [],
			h_fuzpzh: "",
			d_zhaiy: "",
			d_ref1: "",
			d_ref2: "",
			d_ref3: "",
			d_ref4: "",
			d_ref5: "",
			d_ref11: "",
			d_ref12: "",
			d_ref13: "",
			d_ref14: "",
			d_ref15: "",
		},
		form: [{
				prop: "h_cain",
				label: "凭证年度",
				type: "select",
				selectval: [],
				width: "150"
			},
			{
				prop: "h_qij",
				label: "凭证财月",
				type: "select",
				selectval: [],
				width: "150"
			},
			{
				prop: "h_pingzh",
				label: "ERP凭证号 ",
				type: "input",
				width: "150"
			}, {
				prop: "h_xitpzh",
				label: "系统凭证号",
				type: "input",
				width: "150"
			},
			{
				prop: "h_pingzlx",
				label: "凭证类型",
				type: "select",
				selectval: [{
					label: "正常凭证",
					value: "0"
				}, {
					label: "调整凭证",
					value: "1"
				}],
				width: "150"
			},
			{
				prop: "h_guozzt",
				label: "过账状态",
				type: "select",
				selectval: [{
					label: "未过账",
					value: "0"
				}, {
					label: "已过账",
					value: "1"
				}],
				width: "150"
			},
			{
				prop: "d_erpkm",
				label: "ERP科目",
				type: "input",
				width: "150"
			}, {
				prop: "d_zhongfkm",
				label: "中方科目",
				type: "select",
				selectval: [],
				width: "150"
			}, {
				prop: "h_benbjfje",
				label: "凭证借方金额",
				type: "input",
				width: "150"
			}, {
				prop: "h_benbdfje",
				label: "凭证贷方金额",
				type: "input",
				width: "150"
			}, {
				prop: "h_daorpch",
				label: "导入批次号",
				type: "input",
				width: "150"
			}, {
				prop: "d_yuanbz",
				label: "原币币种",
				type: "select",
				selectval: [],
				width: "150"
			}, {
				prop: "h_fuzpzh",
				label: "辅助凭证号",
				type: "input",
				width: "150"
			}, {
				prop: "d_zhaiy",
				label: "凭证摘要",
				type: "input",
				width: "150"
			},
			{
				prop: "d_ref1",
				label: "分析代码1",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref2",
				label: "分析代码2",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref3",
				label: "分析代码3",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref4",
				label: "分析代码4",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref5",
				label: "分析代码5",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref11",
				label: "参考字段1",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref12",
				label: "参考字段2",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref13",
				label: "参考字段3",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref14",
				label: "参考字段4",
				type: "input",
				width: "150"
			}, {
				prop: "d_ref15",
				label: "参考字段5",
				type: "input",
				width: "150"
			},

		],

	}
	return obj
}
